export default {
    activateCardFailure: {
        dataTrackId: 'activate-card-failure',
        dataTrackLinkname: 'aktivere kort feil',
    },
    activateCardSuccess: {
        dataTrackId: 'activate-card-success',
        dataTrackLinkname: 'aktivere kort suksess',
    },
    activateCard: {
        dataTrackId: 'activate-card',
        dataTrackLinkname: 'aktivere kort',
    },
    activateCardModal: {
        dataTrackId: 'activate-card-modal',
        dataTrackLinkname: 'modal aktivere kort',
    },
};
